import { render, staticRenderFns } from "./DocumentConfigEdit.vue?vue&type=template&id=212f267c&"
import script from "./DocumentConfigEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports